import { UnderConstructionComponent } from '@components/shared/under-construction/under-construction.component';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ParkingOverviewComponent } from './components/parking-overview/parking-overview.component';
import { ParkingRequestsTableComponent } from './components/parking-requests/parking-requests-table.component';

@Component({
  selector: 'app-parking',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    TabsModule,
    ButtonModule,
    ParkingRequestsTableComponent,
    ParkingOverviewComponent,
    UnderConstructionComponent
  ],
  template: `<div class="compact-card">
    <div class="card-header mb-4">
      <div class="flex items-center justify-between">
        <div>
          <h1 class="text-2xl font-bold">{{ 'parking.title' | translate }}</h1>
          <p class="mt-1 text-base text-gray-500">{{ 'services.parking.pageDescription' | translate }}</p>
        </div>
        <p-button
          label="{{ 'parking.newRequest' | translate }}"
          icon="pi pi-plus"
          severity="primary"
          (onClick)="onNewParkingRequest()"
          class="ml-4"
        >
        </p-button>
      </div>
    </div>

    <p-tabs
      [value]="activeTabIndex"
      (valueChange)="handleTabChange($event)"
    >
      <p-tablist>
        <p-tab [value]="0">{{ 'parking.tabs.overview' | translate }}</p-tab>
        <p-tab [value]="1">{{ 'parking.tabs.requests' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <!-- Overview Tab -->
        <p-tabpanel [value]="0">
          <div class="mt-4">
            @if (underConstruction) {
              <app-under-construction></app-under-construction>
            } @else {
              <app-parking-overview></app-parking-overview>
            }
          </div>
        </p-tabpanel>

        <!-- Requests Tab -->
        <p-tabpanel [value]="1">
          <app-parking-requests-table></app-parking-requests-table>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>`
})
export class ParkingComponent {
  /**
   * Active tab index (0 = Overview, 1 = Requests)
   */
  activeTabIndex = 0;
  underConstruction = false;

  constructor(private router: Router) {}

  /**
   * Handles the tab change event ensuring proper type conversion
   * @param value - The new tab value (could be number or string)
   */
  handleTabChange(value: string | number): void {
    this.activeTabIndex = typeof value === 'string' ? parseInt(value, 10) : value;
  }

  /**
   * Navigate to new parking request form
   */
  onNewParkingRequest(): void {
    this.router.navigate(['/parking/request/new']);
  }
}
